<template>
  <div class="flex flex-col justify-around items-center text-center w-full">
    <div>
      <div class="m-2.5 text-lg font-light text-black">
        {{ $t('authentication.loading') }}
      </div>
      <div class="relative text-center flex justify-center">
        <div
          class="absolute inset-0 w-full max-w-[70%] h-full mx-auto bg-[#fafafa]/70 bg-[url('../assets/images/scanning-crop.png')] bg-repeat animate-bg-scan rounded-t-[42px]"
        ></div>
        <div
          class="w-10/12 h-1.5 flex flex-col items-center justify-center absolute top-0 bg-[var(--secondary)] animate-scan-line"
        ></div>
        <img
          id="preview"
          :src="photo"
          class="w-full max-w-[70%] max-h-[60vh] rounded-[42px]"
        />
      </div>
    </div>

    <div
      class="bg-[#f1f1f1] p-2.5 rounded text-black ltr:text-left rtl:text-right mx-3.5 mt-10"
    >
      <h2 class="font-bold text-lg m-0">
        {{ $t('authentication.authentication-tips') }}:
      </h2>
      <p class="text-base font-light">{{ tip }}</p>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'

defineProps({
  photo: {
    type: String,
    required: true
  }
})
const { t } = useI18n()
const tip = ref('')

const randomTips = () => {
  const tips = [
    t('authentication.tips.one'),
    t('authentication.tips.two'),
    t('authentication.tips.three'),
    t('authentication.tips.four'),
    t('authentication.tips.five'),
    t('authentication.tips.six')
  ]

  const randomIndex = Math.floor(Math.random() * tips.length)
  tip.value = tips[randomIndex]
}

onMounted(() => {
  randomTips()
})
</script>
